import { selectHighwayIds, selectJsonQuery } from 'shared/selectors/jsonQuery';
import { updateGeo } from 'shared/slices/jsonQuery';
import { TAsyncThunkAction } from 'shared/types/redux';
import { updateSearchMeta } from '../../searchMeta';
import { setHighwaysInJsonQuery } from 'shared/utils/jsonQuery';

export const removeHighways =
  (highwaysIds: number[]): TAsyncThunkAction =>
  async (dispatch, getState) => {
    const state = getState();
    const selectedHighwayIds = selectHighwayIds(state);
    const jsonQuery = selectJsonQuery(state);

    const filteredHighways = selectedHighwayIds.filter(id => !highwaysIds.includes(id));

    const newGeo = setHighwaysInJsonQuery(jsonQuery, filteredHighways);

    dispatch(updateGeo(newGeo));
    dispatch(updateSearchMeta());
  };
